import React from 'react';
import ReactDOM from 'react-dom';

import ProductgroupEditController from './controller/ProductgroupEditController';

window.shop_productgroup_plugin_edit_controller = new ProductgroupEditController();